var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "other-wrapper"
  }, [_c("a-row", {
    staticClass: "other-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "水球图",
      hoverable: true,
      bordered: false
    }
  }, [_c("liquid-chart", {
    staticClass: "chart-other"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "仪表盘",
      hoverable: true,
      bordered: false
    }
  }, [_c("gauge-chart", {
    staticClass: "chart-other"
  })], 1)], 1)], 1), _c("div", {
    staticClass: "other-list"
  }, [_c("a-card", {
    attrs: {
      title: "词云图",
      hoverable: true,
      bordered: false
    }
  }, [_c("word-chart", {
    staticClass: "chart-other"
  })], 1)], 1), _c("a-row", {
    staticClass: "other-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "雷达图",
      hoverable: true,
      bordered: false
    }
  }, [_c("radar-chart", {
    staticClass: "chart-other"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "矩形树图",
      hoverable: true,
      bordered: false
    }
  }, [_c("tree-chart", {
    staticClass: "chart-other"
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };